import React, { useEffect } from "react";
import DigitalLegacyAuth from "../../pages/nonauth/DigitalLegacyAuth/DigitalLegacyAuth";
import { ApplicationState } from "../../store";
import { UserState } from "../../store/reducers/user-reducer";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { AUTHENTICATED_ROUTES, ROUTES } from "../../configs/routes";
import { URLS } from "../../constants/urls";
import { Cookie } from "../../services/storage";
import { REDIRECT_URI, REQUEST_NUMBER } from "../../constants/storage";
import { SPDL_TICKET_NUMBER } from "../../constants/ticketNumberRegex";

interface Props {
  children?: React.ReactNode;
}

const DeepLinkChecker: React.FC<Props> = (props) => {
  const currentURL = window.location.pathname;
  const reqNum = currentURL.split("/").pop();
  const isDLRequestDeepLink = reqNum?.match(SPDL_TICKET_NUMBER);
  const { pathname } = useLocation();

  const { userCountryCode } = useSelector<ApplicationState, UserState>(
    (state) => state.user
  );
  const isLoggedIn = useSelector<ApplicationState, boolean>(
    (state) => state.auth.isLoggedIn
  );


  useEffect(() => {
    if (reqNum && isDLRequestDeepLink && !isLoggedIn) {
      Cookie.set(REQUEST_NUMBER, reqNum);
      Cookie.set(REDIRECT_URI, `${ROUTES.MYDATA_HISTORY}/${reqNum}`);
    }

    if (
      AUTHENTICATED_ROUTES.includes(pathname) &&
      !isLoggedIn
    ) {
      if (userCountryCode === "CN") {
        window.location.replace(URLS.CHINA_LOCALSITE);
      }
    }
  }, [pathname, userCountryCode, isLoggedIn]);

  // IF DEEPLINK is Digital Legacy and user is not yet LOGGED IN, REDIRECT to DL REDIRECT PAGE
  if (isDLRequestDeepLink && !isLoggedIn) {
    return <DigitalLegacyAuth />;
  }
  // IF NORMAL DEEPLINK: RETURN CHILDREN COMPONENTS 
  return (<>{props.children}</>)
};

export default DeepLinkChecker;
